<template>
  <a-tag  :closable="closable"
          :class="['tag', type, size, round ? 'round': '', outline ? 'outline' : '']"
          :color="bgColor"
          @click="handleClick"
          @close="onTagClose"
          :style="{color: color}">
    {{text}}
    <slot></slot>
  </a-tag>
</template>

<script>
export default {
  props: {
    text: String,
    type: {
      type: String,
      default: 'default'
    },
    outline: {
      type: Boolean,
      default: false
    },
    round: Boolean,
    size: {
      type: String,
      default: ''
    },
    closable: Boolean,
    color: String,
    bgColor: String,
    to: Function
  },
  methods: {
    handleClick() {
      this.$emit('to')
    },
    onTagClose($event) {
      this.$emit('close', $event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";

.tag /deep/ .anticon-close {
  vertical-align: middle;
  background: #A8AAAD;
  color: #fff;
  border-radius: 999px;
  padding: 4px;
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 1px;
}
.tag.small /deep/ .anticon-close {
  padding: 3px;
  font-size: 10px;
}
</style>